export function dateFormatter(dateParams, isTime = false) {
    if (!dateParams) {
        return '';
    }
    const date = new Date(dateParams);
    if (isNaN(date.getTime())) {
        return dateParams;
    }
    const day = date.getUTCDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    const formattedDate = `${day} ${month} ${year}`;
    if (isTime) {
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const formattedTime = `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
        return `${formattedDate} ${formattedTime}`;
    }
    return formattedDate;
}

export function emailToName(email) {
    if (email && typeof email === "string" && email?.includes('@')) {
        const parts = email?.split('@');
        if (parts?.length > 1) {
            return parts[0]?.replace(/\./g, ' ')?.split(' ')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
        }
    }
    return email;
}